<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">Shipment</h4>
          <div style="float: right">
          <vs-button @click="exportExcel">Export</vs-button>
        </div>
      </div>
      <div style="float: right" class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-right">
        
      </div>
    <div style="margin-top: 40px" class="vx-row">
      <div class="vx-col w-1/3">
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Warehouse ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.warehouse_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, warehouse)"
                >
                    <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                </vs-select>
              </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Transporter ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.transporter_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, transporter)"
                >
                    <vs-select-item v-for="(item, index) in transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                </vs-select>
              </div>
          </div>
           <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Client ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
              </div>
          </div>
                     <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Vehicle ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.vehicle_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, vehicle)"
                >
                    <vs-select-item v-for="(item, index) in vehicle.data" :key="index" :value="item.id" :text="item.vehicle_code+' - '+item.driver.toUpperCase()"/>
                </vs-select>
              </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Vehicle Type</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.vehicle_type_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, vehicletype)"
                >
                    <vs-select-item v-for="(item, index) in vehicletype.data" :key="index" :value="item.id" :text="item.vehicle_type.toUpperCase()"/>
                </vs-select>
              </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Contract Type</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.contract_type_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, contracttype)"
                >
                    <vs-select-item v-for="(item, index) in contracttype.data" :key="index" :value="item.id" :text="item.contract_type"/>
                </vs-select>
              </div>
          </div>


          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Start Date</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <flat-pickr class="w-full" v-model="form.req_del_date_start" />
              </div>
          </div>

          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>End Date</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <flat-pickr class="w-full" v-model="form.req_del_date_end"/>
              </div>
          </div>
      </div>
    </div>
      
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
  components: {
    vSelect,
    AgGridVue,
    flatPickr,
  },
  data() {
    return {
      gridOptions: {},
      gridApi: null,
      data: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      isLoading: false,
      form: {
        warehouse_id: null,
        transporter_id: null,
        req_del_date_start: null,
        req_del_date_end: null,
        client_id: null,
      }, 
      client: {
        data: [],
        loading: false,
        endpoint: 'master/clients',
        objectKey: 'client_code'
      },
      warehouse: {
        data: [],
        loading: false,
        endpoint: 'master/warehouses',
        objectKey: 'warehouses_code'
      },
      transporter: {
        data: [],
        loading: false,
        endpoint: 'master/transporters',
        objectKey: 'transporter_code'
      },
      vehicle: {
        data: [],
        loading: false,
        endpoint: 'master/vehicle',
        objectKey: 'vehicle_id'
      },
      vehicletype: {
        data: [],
        loading: false,
        endpoint: 'master/vehicletypes',
        objectKey: 'vehicle_type_id'
      },
      contracttype: {
        data: [],
        loading: false,
        endpoint: 'master/contracttypes',
        objectKey: 'contract_type_id'
      },

      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addData() {
      this.isLoading = true;
      this.$http
        .post("report/locationstatus", this.form)
        .then(() => {
          this.isLoading = false;
          this.form = {
            warehouse_id: null,
            location_id: null,
            client_id: null,
            location_type_id: null,
            section_id: null
          };
          this.$vs.notify({
            color: "success",
            title: "Data Added",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected data was successfully Added"
          });
          this.fetchData();
        })
        .catch(error => this.handleError(error))
    },
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
    fetchData() {
      this.isLoading = true;
      Promise.all([
      this.$http.post("master/contracttypes"),
      this.$http.post("master/vehicle"),
      this.$http.post("master/vehicletypes"),
      this.$http.post("master/warehouses"),
      this.$http.post("master/transporters"),
      this.$http.post("master/clients")
      ])
        .then(
          this.$http.spread((contracttype,vehicle,vehicletype,warehouse,transporter,client) => {
            this.contracttype.data = contracttype.data.data;
            this.vehicle.data = vehicle.data.data;
            this.vehicletype.data = vehicletype.data.data;
            this.warehouse.data = warehouse.data.data;
            this.transporter.data = transporter.data.data;
            this.client.data = client.data.data
          })
        )
        .catch(() => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Error",
            text: "Try again?",
            accept: () => {
              this.refreshData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.isLoading = false));
    },
      exportExcel() {
            this.isLoading = true;
            this.$http
                .post("report/shipment", this.form, {
                    responseType: "blob"
                })
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    this.isLoading = false;
                    saveAs(blob, "Transporters-list-export.xlsx");
                });
        },
    
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
  this.columnDefs = [
    {
      headerName: "Warehouse Code",
      field: "warehouses_code",
      width: 150,
    }
  ];
}
};
</script>